// @flow
import React from 'react'
import glamorous, { ThemeProvider } from 'glamorous'
import { Link } from 'components'
import InstagramIcon from 'assets/icons/Instagram.svg'
import { colors, transition, typography, padding } from 'style'
import { trackOutboundLink } from 'analytics'

import type { CSS } from 'glamorous'

const primaryTheme = {
  link: {
    color: colors.primary,
    ':after': {
      ...transition.medium('transform'),
      content: "''",
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: 1,
      width: '100%',
      backgroundColor: colors.primary,
      transform: 'scaleX(0)',
    },
    ':hover:after': {
      transform: 'scaleX(0.8)',
    },
  },
}

const subtleTheme = {
  link: {
    color: colors.gray600,
  },
}

const Nav = glamorous.nav({
  display: 'flex',
})

const NavLink = glamorous(Link)(
  {
    ...typography.nav,
    ...padding.x(3),
    ...padding.y(2),
    ...transition.medium('color'),
    position: 'relative',
    textDecoration: 'none',
    ':hover': {
      color: colors.primaryDark,
    },
  },
  ({ theme }: { theme?: { [key: string]: CSS } }) => ({
    ...(theme && theme.link),
  }),
)

const InstaLink = glamorous.a({
  ...padding.x(3),
  ...padding.y(2),
  ...transition.medium('color'),
  color: colors.gray600,
  ':hover': {
    color: colors.primaryDark,
  },
})

type Props = {
  subtle?: boolean,
}

const Navigation = ({ subtle = false }: Props) => (
  <ThemeProvider theme={subtle ? subtleTheme : primaryTheme}>
    <Nav>
      <NavLink href="/">Work</NavLink>
      <NavLink href="/about">About</NavLink>
      <NavLink href="/contact">Contact</NavLink>
      <NavLink
        className="js-external-link"
        href="https://melissaohearn.tumblr.com"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackOutboundLink('https://melissaohearn.tumblr.com')}
      >
        Blog
      </NavLink>
      <InstaLink
        href="https://instagram.com/melissaohearn"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackOutboundLink('https://instagram.com/melissaohearn')}
      >
        <InstagramIcon width={20} height={20} />
      </InstaLink>
    </Nav>
  </ThemeProvider>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation.js